import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-maintaince-ticket-form',
  templateUrl: './maintaince-ticket-form.component.html',
  styleUrls: ['./maintaince-ticket-form.component.scss']
})
export class MaintainceTicketFormComponent implements OnInit {
public ticket:any={};
technicians = ['Tech 1', 'Tech 2', 'Tech 3'];
lines = ['Line 1', 'Line 2'];
machines = ['Machine 1', 'Machine 2'];

durationFields = [
  'Total Duration',
  'Operator Time Duration',
  'PED Time Duration',
  'Maintenance Time Duration'
];
yesNoFields = [
  { key: 'MT_SpareReplacementRequest', label: 'Spare Replacement Request' },
  { key: 'MT_AdjustmentRequest', label: 'Adjustment Request' },
  { key: 'MT_TestingCompleted', label: 'Testing Completed' },
  { key: 'MT_HandoverAcceptance', label: 'Handover Acceptance' },
  { key: 'MT_DimensionCompleted', label: 'Dimension Completed' }
];
  constructor(public appservice:AppService,public toastr:ToastrService) { }
Onsubmit(){
  console.log(this.ticket)
  
  this.appservice.postTable("api/Transaction/insert_MaintenanceTicket",this.ticket).subscribe(
    {
      next:(res:any)=>{
if(res){
  this.toastr.success("The Details Saved","Notice");
}
    },
  error: (err) => {
  this.toastr.error(err.error || 'Server Error', 'Error');
}}
  );
}
  ngOnInit(): void {
this.ticket.MT_TicketClosed= new Date().toISOString().split('T')[0];
this.ticket.MT_TicketOpen= new Date().toISOString().split('T')[0];
  }

}
